export default __webpack_public_path__ + "static/media/rank3.78dfab83.svg";